import { IUserAuctionConfiguration } from '../../../../repositories/billing-tariffs/entities/Models/UserAuctionConfiguration';
import { IAuctionConfigurations } from '../../../../types/reducers/auction';
import { EServiceType } from '../../../../types/reducers/publishTerms';
import { mapInternalServiceTypes, getServiceId } from '../../../../utils/publishTerms';

export function mapAuctionConfigurations(configurations?: IUserAuctionConfiguration[] | null): IAuctionConfigurations {
  if (!configurations) {
    return {};
  }

  return configurations.reduce((acc, configuration) => {
    const { serviceTypes, stepBet } = configuration;

    const services = mapInternalServiceTypes<EServiceType>(serviceTypes);
    const serviceId = getServiceId(services);

    acc[serviceId] = {
      serviceId,
      betStep: stepBet,
    };

    return acc;
  }, {} as IAuctionConfigurations);
}
